var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"rf","enable-background":"new 0 0 512.004 512.004","width":"14","height":"14","viewBox":"0 0 512.004 512.004","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":_vm.path11 + _vm.path12 + _vm.path13 + _vm.path14 + _vm.path15}}),_c('path',{attrs:{"d":_vm.path21 + _vm.path22 + _vm.path23}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }